import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import apiCall from "../Api/api";
import dummyImage from "../../assets/img/Article5.jpg";
import img1 from "../../assets/img/SightingImgs/img1.png";
import img2 from "../..//assets/img/SightingImgs/img2.png";
import img3 from "../../assets/img/SightingImgs/img3.png";
import img4 from "../../assets/img/SightingImgs/img4.png";
import img5 from "../../assets/img/SightingImgs/img5.png";
import img6 from "../../assets/img/SightingImgs/img6.png";
import img7 from "../../assets/img/SightingImgs/img7.png";
import img8 from "../../assets/img/SightingImgs/img8.png";
import img9 from "../../assets/img/SightingImgs/img9.png";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import { Link, useNavigate } from "react-router-dom";

const DailySightUpdate = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [imageList, setImageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiCall({
          url: "sighting/daily-update",
          method: "GET",
        });
        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }
        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            // Dynamically set errors based on the response
            console.error(errors);
          } else {
            const sightingData = response?.data?.sighting?.data;
            setImageList(sightingData);
          }
        }
      } catch (error) {
        console.error("Network or API call error:", error);
        handleError(error, logout, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getBoxWidth = () => {
    if (windowWidth <= 430) return "85%";
    if (windowWidth <= 768) return "280px";
    return "360px";
  };

  const getColSize = () => {
    if (windowWidth <= 430) return 12;
    if (windowWidth <= 768) return 6;
    return 4;
  };

  return (
    <div className="position-relative">
      <div
        className="btn-top sight-btn"
        style={{
          position: "fixed",
          bottom: "0px",
          right: windowWidth <= 430 ? "50%" : "90px",
          transform: windowWidth <= 430 ? "translateX(50%)" : "none",
          zIndex: 999,
          padding: "10px 6px",
          border: "none",
          fontSize: "20px",
          cursor: "pointer",
          width: getBoxWidth(),
          boxShadow: "0px 3px 6px #00000029",
          background: "#fff",
          border: "1px solid #7070704D",
          transition: "width 0.3s ease, height 0.3s ease",
        }}
        title="Back to top"
      >
        <Row>
          <Col xs={12} className="mb-2">
            <div
              className="position-relative text-center"
              onClick={toggleCollapse}
            >
              <h5 className="mb-0 sight-title w-100">DAILY SIGHTING UPDATES</h5>
              <button
                type="button"
                onClick={toggleCollapse}
                style={{
                  position: "absolute",
                  right: "0",
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  
                }}
              >
                {isCollapsed ? (
                  <SlArrowUp style={{ color: "#152F1B" }} />
                ) : (
                  <SlArrowDown style={{ color: "#152F1B" }} />
                )}
              </button>
            </div>
          </Col>
        </Row>

        {!isCollapsed && (
          <>
            {loading ? (
              <div className="text-center py-2">Loading updates...</div>
            ) : error ? (
              <div className="text-danger text-center py-2">{error}</div>
            ) : (
              <Row
                className="gx-1"
                style={{
                  overflowY: "auto",
                  maxHeight: "250px",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {images.length === 0
                  ? [...Array(6)].map((_, idx) => (
                      <Col xs={getColSize()} className="mb-1" key={idx}>
                        <div className="h-100">
                          <Link to="">
                            <img
                              src={images}
                              alt={`dummy-sighting-${idx}`}
                              className="w-100 h-100 object-fit-cover rounded-0"
                              style={{ objectFit: "cover" }}
                            />
                          </Link>
                        </div>
                        <p className="">Not featching Api Data</p>
                      </Col>
                    ))
                  : images.map((imageSrc, idx) => (
                      <Col xs={getColSize()} className="mb-1" key={idx}>
                        <div className="h-100">
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.mediarc.walkintothewild",
                                "_blank"
                              );
                            }}
                          >
                            <img
                              src={imageSrc}
                              alt={`sighting-${idx}`}
                              className="w-100 h-100 object-fit-cover rounded-0"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = dummyImage;
                              }}
                            />
                          </Link>
                        </div>
                      </Col>
                    ))}
              </Row>
            )}
          </>
        )}

        <div
          className="footer-Download py-2 px-3 text-center"
          style={{ background: "#F7BF39" }}
        >
          <p className="mb-0 sight-text" style={{ fontSize: "12px" }}>
            <strong>
              View daily animal sighting updates from all the parks.
            </strong>
          </p>
          <div className="downloadBtn text-center position-relative">
            <button
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.mediarc.walkintothewild",
                  "_blank"
                )
              }
              type="btn"
              style={{
                border: "0",
                outline: "none",
                background: "#09432D",
                padding: "5px 70px",
                borderRadius: "20px",
                color: "#fff",
                fontSize: "13px",
              }}
            >
              Download App
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailySightUpdate;
